import { useQuery } from 'react-query';

import { getShortenLink, type GetShortenLinkResponse } from '../../services/shortenLinksService';

export function useGetShortenLink(key: string | undefined) {
  return useQuery<GetShortenLinkResponse, Error>(['shortenLink', key], () => getShortenLink(key!), {
    enabled: !!key,
    staleTime: 60 * 10 * 1000,
    cacheTime: 60 * 10 * 1000
  });
}
